// Corsac motion: smooth scroll, masked line reveals, fades, media unveils, drift and scroll-fill text.
(function () {
  const CX = window.CX;
  const { $$ } = CX;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));

  /* ---------- Smooth scroll (Lenis) ---------- */
  // Lenis loads async; smooth scroll starts whenever it arrives and the page works without it.
  const initLenis = () => {
    if (!window.Lenis || CX.calm || CX.lenis) return;
    // autoRaf keeps one steady animation loop; stopping and restarting it on idle caused visible hitches.
    CX.lenis = new window.Lenis({ autoRaf: true, lerp: 0.16, smoothWheel: true, syncTouch: false });
    // Scroll-linked sections listen to native scroll; Lenis moves the real scroll position, so they stay in step.
  };
  const lenisTag = document.getElementById('cx-lenis');
  if (window.Lenis) initLenis();
  else if (lenisTag) lenisTag.addEventListener('load', initLenis);
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || !CX.lenis || a.getAttribute('href').length < 2) return;
    const target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    CX.lenis.scrollTo(target, { offset: -20 });
  });

  /* ---------- Masked line reveal for headings ---------- */
  // Words keep the classes of the inline element they sit in (e.g. the serif accent); <br> forces a new line.
  const splitLines = (el) => {
    if (!el.dataset.cxSource) el.dataset.cxSource = el.innerHTML;
    const tmp = document.createElement('div');
    tmp.innerHTML = el.dataset.cxSource;
    const words = [];
    const walk = (node, cls) => {
      node.childNodes.forEach((child) => {
        if (child.nodeType === 3) {
          child.textContent.split(/\s+/).filter(Boolean).forEach((w) => words.push({ w, cls }));
        } else if (child.nodeName === 'BR') {
          if (!(child.className && /cx-br-wide/.test(child.className) && !CX.wide())) words.push({ br: true });
        } else if (child.nodeType === 1) {
          walk(child, [cls, child.className].filter(Boolean).join(' '));
        }
      });
    };
    walk(tmp, '');
    el.innerHTML = words.map((t) => (t.br ? '<br>' : `<span class="cx-wd ${t.cls}">${CX.esc(t.w)}</span>`)).join(' ');
    const lines = [];
    let top = null;
    [...el.children].forEach((node) => {
      if (node.nodeName === 'BR') { top = null; return; }
      // A word starts a new line once it sits clearly below the current one (mixed fonts shift baselines a little).
      if (top === null || node.offsetTop > top + node.offsetHeight * 0.6) { lines.push([]); top = node.offsetTop; }
      lines[lines.length - 1].push(node.outerHTML);
    });
    el.innerHTML = lines.map((l, i) => `<span class="cx-l" style="--l:${i}"><span>${l.join(' ')}</span></span>`).join('');
    el.classList.add('is-split');
  };
  const splitAll = (root = document) => $$('[data-cx-lines]', root).forEach(splitLines);
  CX.splitLines = splitAll;

  /* ---------- Reveal on enter ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
  CX.observe = (root = document) => {
    splitAll(root);
    $$('[data-cx-lines], [data-cx-fade], [data-cx-unveil], [data-cx-in]', root).forEach((el) => {
      if (!el.classList.contains('is-in')) io.observe(el);
    });
    $$('[data-cx-fill]', root).forEach(prepFill);
    collect();
  };

  /* ---------- Scroll-fill text: words light up as the block passes ---------- */
  const fills = [];
  function prepFill(el) {
    if (el.dataset.cxFillReady) return;
    el.dataset.cxFillReady = '1';
    const words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map((w) => `<span class="cx-word" aria-hidden="true">${CX.esc(w)}</span>`).join(' ');
    fills.push({ el, words: $$('.cx-word', el) });
  }

  /* ---------- Scroll-linked work, one rAF per frame ---------- */
  let drifts = [];
  function collect() { drifts = $$('[data-cx-drift]'); }
  const update = () => {
    queued = false;
    const vh = window.innerHeight;
    fills.forEach(({ el, words }) => {
      const r = el.getBoundingClientRect();
      const p = CX.calm ? 1 : clamp((vh * 0.88 - r.top) / (r.height + vh * 0.38));
      const lit = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('is-lit', i < lit));
    });
    if (CX.calm) return;
    drifts.forEach((el) => {
      const host = el.parentElement.getBoundingClientRect();
      if (host.bottom < -200 || host.top > vh + 200) return;
      const off = host.top + host.height / 2 - vh / 2;
      el.style.transform = `translate3d(0, ${(off * Number(el.dataset.cxDrift)).toFixed(1)}px, 0)`;
    });
  };
  let queued = false;
  const request = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', request, { passive: true });

  // Headings re-flow on resize; only re-split ones that haven't animated yet or whose width changed.
  let w = window.innerWidth;
  window.addEventListener('resize', () => {
    request();
    if (window.innerWidth === w) return;
    w = window.innerWidth;
    clearTimeout(splitAll.t);
    splitAll.t = setTimeout(() => splitAll(), 150);
  });

  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    document.documentElement.classList.add('cx-motion');
    CX.observe();
    request();
  };
  // Split after web fonts load so lines are measured in the right face, but never wait more than 1.2s.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
  setTimeout(start, 1200);
})();
